module.exports = __webpack_public_path__ + "static/img/Big Data.57a947a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/technology/Big Data.jpg
// module id = GGwI
// module chunks = 1